var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"turntable-container"},[_c('div',{ref:"turntable",staticClass:"turntable",attrs:{"data-spin-reverse":"","data-image-list":JSON.stringify(_vm.urls)}})])}
var staticRenderFns = []

export { render, staticRenderFns }